import { SchedulerTimeslotRange } from '@wix/wix-chatbot-common/selectors';
import { nanoid } from 'nanoid';

import { MESSAGES } from '../../constants';

export interface ITimeslotSelector {
  readonly id: string;
  readonly type: MESSAGES.TIMESLOT_SELECTOR;
  readonly nodeId: string;
  readonly items: SchedulerTimeslotRange[];
  readonly rm?: boolean;
  readonly role?: string;
}

export const createTimeslotSelector = (data): ITimeslotSelector => {
  return {
    id: nanoid(),
    type: MESSAGES.TIMESLOT_SELECTOR,
    nodeId: data.nodeId,
    items: data.items,
    rm: Boolean(data.rm),
  };
};
